import { useState } from "react";
import { Check, X } from "lucide-react";
import { Button } from "../ui/button";
import { PresetButtons, buildPresets } from "../PeriodPresets";
import { friendlyRange } from "./compare/headlineTotals";

export const ReportPeriodEditor = ({ start, end, months, onSave, onClose }) => {
  const [from, setFrom] = useState(start || "");
  const [to, setTo] = useState(end || "");
  const presets = buildPresets(months);
  const active = presets.find((p) => p.start === from && p.end === to)?.key;
  const valid = from && to && from <= to;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose} data-testid="report-period-editor">
      <div className="bg-white rounded-2xl p-5 md:p-6 w-full max-w-lg shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-base font-semibold text-slate-800">Change report dates</h3>
            <p className="text-xs text-slate-500 mt-0.5">Pick a quick option or set your own dates.</p>
          </div>
          <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="report-period-close">
            <X className="w-5 h-5" />
          </button>
        </div>

        {presets.length > 0 && (
          <div className="mb-5">
            <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2">Quick pick</p>
            <PresetButtons presets={presets} active={active} onSelect={(p) => { setFrom(p.start); setTo(p.end); }} />
          </div>
        )}

        <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2">Custom dates</p>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-slate-500">
            From
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800" data-testid="report-start-input" />
          </label>
          <label className="text-xs text-slate-500">
            To
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800" data-testid="report-end-input" />
          </label>
        </div>

        <div className="mt-5 flex items-center justify-between gap-3">
          <p className="text-sm font-semibold text-slate-700" data-testid="report-period-preview">{valid ? friendlyRange(from, to) : "Choose a start and end date"}</p>
          <div className="flex gap-2">
            <Button size="sm" variant="outline" className="rounded-lg" onClick={onClose} data-testid="report-period-cancel">Cancel</Button>
            <Button size="sm" disabled={!valid} className="bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg" onClick={() => onSave(from, to)} data-testid="save-report-period-btn">
              <Check className="w-4 h-4 mr-1" /> Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
